
import { Zap } from "lucide-react";

interface SyncIndicatorsProps {
  isSyncing: boolean;
  lastSyncTime?: number;
  className?: string;
}

export const SyncIndicators = ({ isSyncing, lastSyncTime, className = "" }: SyncIndicatorsProps) => {
  return (
    <>
      {/* Indicador de sincronización activa */}
      {isSyncing && (
        <div className={`w-2 h-2 bg-blue-400 rounded-full animate-bounce ${className}`}></div>
      )}
      
      {/* Indicador de sincronización exitosa */}
      {lastSyncTime && lastSyncTime < 200 && !isSyncing && (
        <div className={`w-2 h-2 bg-green-400 rounded-full ${className}`}></div>
      )}
      
      {/* Indicador de sincronización ultra-rápida (absoluto) */}
      {isSyncing && (
        <div className="absolute top-1 right-1 text-blue-400">
          <Zap className="h-3 w-3 animate-spin" />
        </div>
      )}
    </>
  );
};
